import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleGetOutfits = async (capsuleId, withLayers) => {
  try {
    const response = await instance.get(`/outfits?capsule_id=${capsuleId}&with_layers=${withLayers}`);

    return response;
  } catch (error) {
    return error;
  }
};

export const handleGetCurrentUserOutfits = async (userId) => {
  try {
    const response = await instance.get(`/users/${userId}/outfits`);

    return response;
  } catch (error) {
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/api/outfit/index.js